const COUNTRY = Object.freeze([
  { name: '안도라', name_en: 'ANDORRA', code: 'AD' },
  { name: '아랍에미리트', name_en: 'UNITED ARAB EMIRATES', code: 'AE' },
  { name: '아프가니스탄', name_en: 'AFGHANISTAN', code: 'AF' },
  { name: '안티구아 바부다', name_en: 'ANTIGUA AND BARBUDA', code: 'AG' },
  { name: '앙길라', name_en: 'ANGUILLA', code: 'AI' },
  { name: '알바니아', name_en: 'ALBANIA', code: 'AL' },
  { name: '아르메니아', name_en: 'ARMENIA', code: 'AM' },
  /* {name: '네덜란드령 안틸레스', name_en: 'NETHERLANDS ANTILLES', code: 'AN'}, */
  { name: '앙골라', name_en: 'ANGOLA', code: 'AO' },
  { name: '안타티카', name_en: 'ANTARCTICA', code: 'AQ' },

  { name: '아르헨티나', name_en: 'ARGENTINA', code: 'AR' },
  /* {name: '아메리칸 사모아', name_en: 'AMERICAN SAMOA', code: 'AS'}, */
  { name: '오스트리아', name_en: 'AUSTRIA', code: 'AT' },
  { name: '호주', name_en: 'AUSTRALIA', code: 'AU' },
  { name: '아루바', name_en: 'ARUBA', code: 'AW' },
  { name: '알랜드 군도', name_en: 'ALAND ISLANDS', code: 'AX' },
  { name: '아제르바이잔', name_en: 'AZERBAIJAN', code: 'AZ' },
  { name: '보스니아 헤르체고비나', name_en: 'BOSNIA HERCEGOVINA', code: 'BA' },
  { name: '바베이도스', name_en: 'BARBADOS', code: 'BB' },
  { name: '방글라데시', name_en: 'BANGLADESH', code: 'BD' },

  { name: '벨기에', name_en: 'BELGIUM', code: 'BE' },
  { name: '부르키나파소', name_en: 'BURKINA FASO', code: 'BF' },
  { name: '불가리아', name_en: 'BULGARIA', code: 'BG' },
  { name: '바레인', name_en: 'BAHRAIN', code: 'BH' },
  { name: '브룬디', name_en: 'BURUNDI', code: 'BI' },
  { name: '베냉', name_en: 'BENIN', code: 'BJ' },
  /* {name: '세인트 바르탤르미', name_en: 'SAINT BARTHELEMY', code: 'BL'}, */
  { name: '버뮤다', name_en: 'BERMUDA', code: 'BM' },
  { name: '브루나이', name_en: 'BRUNEI DARUSSALAM', code: 'BN' },
  { name: '볼리비아', name_en: 'BOLIVIA', code: 'BO' },

  { name: '보네르', name_en: 'BONAIRE', code: 'BQ' },
  { name: '브라질', name_en: 'BRAZIL', code: 'BR' },
  { name: '바하마', name_en: 'BAHAMAS', code: 'BS' },
  { name: '부탄', name_en: 'BHUTAN', code: 'BT' },
  { name: '부베섬', name_en: 'BOUVET ISLAND', code: 'BV' },
  { name: '보츠와나', name_en: 'BOTSWANA', code: 'BW' },
  { name: '벨라루스', name_en: 'BELARUS', code: 'BY' },
  { name: '벨리즈', name_en: 'BELIZE', code: 'BZ' },
  { name: '캐나다', name_en: 'CANADA', code: 'CA' },
  /*    {name: '코코스 제도', name_en: 'COCOS (KEELING) ISLANDS', code: 'CC'}, */

  { name: '콩고민주공화국', name_en: 'Democratic Republic of the Congo', code: 'CD' },
  { name: '중앙아프리카공화국', name_en: 'CENTRAL AFRICAN REPUBLIC', code: 'CF' },
  { name: '콩고', name_en: 'CONGO', code: 'CG' },
  { name: '스위스', name_en: 'SWITZERLAND', code: 'CH' },
  { name: '코트디부아르', name_en: 'COTE D`IVOIRE', code: 'CI' },
  /* {name: '쿡 제도', name_en: 'COOK ISLANDS', code: 'CK'}, */
  { name: '칠레', name_en: 'CHILE', code: 'CL' },
  { name: '카메룬', name_en: 'CAMEROON', code: 'CM' },
  { name: '중국', name_en: 'CHINA', code: 'CN' },
  { name: '콜롬비아', name_en: 'COLOMBIA', code: 'CO' },

  { name: '코스타리카', name_en: 'COSTA RICA', code: 'CR' },
  { name: '쿠바', name_en: 'CUBA', code: 'CU' },
  { name: '카보베르데', name_en: 'CAPE VERDE', code: 'CV' },
  { name: '큐라소', name_en: 'CURACAO', code: 'CW' },
  { name: '크리스마스섬', name_en: 'CHRISTMAS ISLAND', code: 'CX' },
  { name: '사이프러스', name_en: 'CYPRUS', code: 'CY' },
  { name: '체코공화국', name_en: 'CZECH REPUBLIC', code: 'CZ' },
  { name: '독일', name_en: 'GERMANY', code: 'DE' },
  { name: '지부티', name_en: 'DJIBOUTI', code: 'DJ' },
  { name: '덴마크', name_en: 'DENMARK', code: 'DK' },

  { name: '도미니카', name_en: 'DOMINICA', code: 'DM' },
  { name: '도미니카 공화국', name_en: 'DOMINICAN REPUBLIC', code: 'DO' },
  { name: '알제리', name_en: 'ALGERIA', code: 'DZ' },
  { name: '에쿠아도르', name_en: 'ECUADOR', code: 'EC' },
  { name: '에스토니아', name_en: 'ESTONIA', code: 'EE' },
  { name: '이집트', name_en: 'EGYPT', code: 'EG' },
  { name: '서사하라', name_en: 'WESTERN SAHARA', code: 'EH' },
  { name: '에리트레아', name_en: 'ERITREA', code: 'ER' },
  { name: '스페인', name_en: 'SPAIN', code: 'ES' },
  { name: '이디오피아', name_en: 'ETHIOPIA', code: 'ET' },

  { name: '핀란드', name_en: 'FINLAND', code: 'FI' },
  { name: '피지', name_en: 'FIJI', code: 'FJ' },
  { name: '포클랜드섬', name_en: 'FALKLAND ISLANDS', code: 'FK' },
  { name: '미크로네시아', name_en: 'MICRONESIA', code: 'FM' },
  { name: '페로 군도', name_en: 'FAROE ISLANDS', code: 'FO' },
  { name: '프랑스', name_en: 'FRANCE', code: 'FR' },
  { name: '가봉', name_en: 'GABON', code: 'GA' },
  { name: '영국', name_en: 'UNITED KINGDOM', code: 'GB' },
  { name: '그레나다', name_en: 'GRENADA', code: 'GD' },
  { name: '구루지아', name_en: 'GEORGIA', code: 'GE' },

  /* {name: '프랑스령 기아나', name_en: 'FRENCH GUIANA', code: 'GF'}, */
  { name: '건지', name_en: 'GUERNSEY', code: 'GG' },
  { name: '가나', name_en: 'GHANA', code: 'GH' },
  { name: '지브랄타', name_en: 'GIBRALTAR', code: 'GI' },
  { name: '그린랜드', name_en: 'GREENLAND', code: 'GL' },
  { name: '감비아', name_en: 'GAMBIA', code: 'GM' },
  { name: '기니', name_en: 'GUINEA', code: 'GN' },
  { name: '과들루프', name_en: 'GUADELOUPE', code: 'GP' },
  { name: '적도 기니', name_en: 'EQUATORIAL GUINEA', code: 'GQ' },
  { name: '그리스', name_en: 'GREECE', code: 'GR' },

  /* {name: '사우스조지아 사우스샌드위치 제도', name_en: 'SOUTH GEORGIA AND SOUTH SANDWICH LSLANDS', code: 'GS'}, */
  { name: '과테말라', name_en: 'GUATEMALA', code: 'GT' },
  { name: '괌', name_en: 'GUAM', code: 'GU' },
  { name: '기네비쏘', name_en: 'GUINEA-BISSAU', code: 'GW' },
  { name: '가이아나', name_en: 'GUYANA', code: 'GY' },
  { name: '홍콩', name_en: 'HONG KONG', code: 'HK' },
  /* {name: '허드 맥도날드 군도', name_en: 'HEARD AND MCDONALD ISLANDS', code: 'HM'}, */
  { name: '온두라스', name_en: 'HONDURAS', code: 'HN' },
  { name: '크로아티아', name_en: 'CROATIA', code: 'HR' },
  { name: '아이티', name_en: 'HAITI', code: 'HT' },

  { name: '헝가리', name_en: 'HUNGARY', code: 'HU' },
  { name: '인도네시아', name_en: 'INDONESIA', code: 'ID' },
  { name: '아일랜드', name_en: 'IRELAND', code: 'IE' },
  { name: '이스라엘', name_en: 'ISRAEL', code: 'IL' },
  { name: '맨섬', name_en: 'ISLE OF MAN', code: 'IM' },
  { name: '인도', name_en: 'INDIA', code: 'IN' },
  /* {name: '영인도 제도', name_en: 'BRITISH INDIAN OCEAN TERRITORY', code: 'IO'}, */
  { name: '이라크', name_en: 'IRAQ', code: 'IQ' },
  { name: '이란', name_en: 'IRAN', code: 'IR' },
  { name: '아이슬랜드', name_en: 'ICELAND', code: 'IS' },

  { name: '이탈리아', name_en: 'ITALY', code: 'IT' },
  { name: '저지', name_en: 'JERSEY', code: 'JE' },
  { name: '자메이카', name_en: 'JAMAICA', code: 'JM' },
  { name: '요르단', name_en: 'JORDAN', code: 'JO' },
  { name: '일본', name_en: 'JAPAN', code: 'JP' },
  { name: '케냐', name_en: 'KENYA', code: 'KE' },
  { name: '키르기스스탄', name_en: 'KYRGYZSTAN', code: 'KG' },
  { name: '캄보디아', name_en: 'CAMBODIA', code: 'KH' },
  { name: '키리바시', name_en: 'KIRIBATI', code: 'KI' },
  { name: '코모르', name_en: 'COMOROS', code: 'KM' },

  /* {name: '세인트 키츠 네비스', name_en: 'SAINT KITTS AND NEVIS', code: 'KN'}, */
  { name: '북한', name_en: 'NORTH KOREA', code: 'KP' },
  { name: '대한민국', name_en: 'SOUTH KOREA', code: 'KR' },
  { name: '코소보', name_en: 'KOSOVO', code: 'XK' },
  { name: '쿠웨이트', name_en: 'KUWAIT', code: 'KW' },
  { name: '케이맨섬', name_en: 'CAYMAN ISLANDS', code: 'KY' },
  { name: '카자흐스탄', name_en: 'KAZAKHSTAN', code: 'KZ' },
  { name: '라오스', name_en: 'LAOS', code: 'LA' },
  { name: '레바논', name_en: 'LEBANON', code: 'LB' },
  /* {name: '세인트 루시아', name_en: 'SAINT LUCIA', code: 'LC'}, */

  { name: '리히텐슈타인', name_en: 'LIECHTENSTEIN', code: 'LI' },
  { name: '스리랑카', name_en: 'SRI LANKA', code: 'LK' },
  { name: '라이베리아', name_en: 'LIBERIA', code: 'LR' },
  { name: '레소토', name_en: 'LESOTHO', code: 'LS' },
  { name: '리투아니아', name_en: 'LITHUANIA', code: 'LT' },
  { name: '룩셈부르크', name_en: 'LUXEMBOURG', code: 'LU' },
  { name: '라트비아', name_en: 'LATVIA', code: 'LV' },
  { name: '리비아', name_en: 'LIBYAN ARAB JAMAHIRIYA', code: 'LY' },
  { name: '모로코', name_en: 'MOROCCO', code: 'MA' },
  { name: '모나코', name_en: 'MONACO', code: 'MC' },

  { name: '몰도바', name_en: 'MOLDOVA', code: 'MD' },
  { name: '세인트 마틴', name_en: 'SAINT MARTIN (FRENCH PART)', code: 'MF' },
  { name: '마다가스카르', name_en: 'MADAGASCAR', code: 'MG' },
  { name: '마샬군도', name_en: 'MARSHALL ISLANDS', code: 'MH' },
  { name: '마케도니아', name_en: 'MACEDONIA', code: 'MK' },
  { name: '말리', name_en: 'MALI', code: 'ML' },
  { name: '미얀마', name_en: 'MYANMAR', code: 'MM' },
  { name: '몽골', name_en: 'MONGOLIA', code: 'MN' },
  { name: '마카오', name_en: 'MACAU', code: 'MO' },
  /* {name: '북마리아나 군도', name_en: 'NORTHERN MARIANA ISLANDS', code: 'MP'}, */

  { name: '마르티니크', name_en: 'MARTINIQUE', code: 'MQ' },
  { name: '모리타니', name_en: 'MAURITANIA', code: 'MR' },
  { name: '몬트세라트', name_en: 'MONTSERRAT', code: 'MS' },
  { name: '말타', name_en: 'MALTA', code: 'MT' },
  { name: '모리셔스', name_en: 'MAURITIUS', code: 'MU' },
  { name: '몰디브', name_en: 'MALDIVES', code: 'MV' },
  { name: '말라위', name_en: 'MALAWI', code: 'MW' },
  { name: '멕시코', name_en: 'MEXICO', code: 'MX' },
  { name: '모잠비크', name_en: 'MOZAMBIQUE', code: 'MZ' },
  { name: '나미비아', name_en: 'NAMIBIA', code: 'NA' },

  { name: '뉴칼레도니아', name_en: 'NEW CALEDONIA', code: 'NC' },
  { name: '니제르', name_en: 'NIGER', code: 'NE' },
  { name: '노퍽섬', name_en: 'NORFOLK ISLAND', code: 'NF' },
  { name: '나이지리아', name_en: 'NIGERIA', code: 'NG' },
  { name: '니카라과', name_en: 'NICARAGUA', code: 'NI' },
  { name: '네덜란드', name_en: 'NETHERLANDS', code: 'NL' },
  { name: '노르웨이', name_en: 'NORWAY', code: 'NO' },
  { name: '네팔', name_en: 'NEPAL', code: 'NP' },
  { name: '나우루', name_en: 'NAURU', code: 'NR' },

  { name: '중립지대', name_en: 'NEUTRAL ZONE', code: 'NT' },
  { name: '니우에', name_en: 'NIUE', code: 'NU' },
  { name: '뉴질랜드', name_en: 'NEW ZEALAND', code: 'NZ' },
  { name: '오만', name_en: 'OMAN', code: 'OM' },
  { name: '파나마', name_en: 'PANAMA', code: 'PA' },
  { name: '페루', name_en: 'PERU', code: 'PE' },
  { name: '필리핀', name_en: 'PHILIPPINES', code: 'PH' },
  { name: '파키스탄', name_en: 'PAKISTAN', code: 'PK' },
  { name: '폴란드', name_en: 'POLAND', code: 'PL' },
  /* {name: '세인트 피에르 미클론', name_en: 'SAINT PIERRE AND MIQUELON', code: 'PM'}, */

  { name: '핏케언 군도', name_en: 'PITCAIRN', code: 'PN' },
  { name: '푸에르토리코', name_en: 'PUERTO RICO', code: 'PR' },
  { name: '팔레스타인', name_en: 'PALESTINE', code: 'PS' },
  { name: '포르투갈', name_en: 'PORTUGAL', code: 'PT' },
  { name: '팔라우', name_en: 'PALAU', code: 'PW' },
  { name: '파라과이', name_en: 'PARAGUAY', code: 'PY' },
  { name: '카타르', name_en: 'QATAR', code: 'QA' },
  { name: '리유니언', name_en: 'REUNION', code: 'RE' },
  { name: '루마니아', name_en: 'ROMANIA', code: 'RO' },
  { name: '세르비아', name_en: 'SERBIA', code: 'RS' },

  { name: '러시아', name_en: 'RUSSIAN FEDERATION', code: 'RU' },
  { name: '르완다', name_en: 'RWANDA', code: 'RW' },
  { name: '사우디아라비아', name_en: 'SAUDI ARABIA', code: 'SA' },
  { name: '솔로몬 군도', name_en: 'SOLOMON ISLANDS', code: 'SB' },
  { name: '이셸', name_en: 'SEYCHELLES', code: 'SC' },
  { name: '수단', name_en: 'SUDAN', code: 'SD' },
  { name: '스웨덴', name_en: 'SWEDEN', code: 'SE' },
  { name: '싱가포르', name_en: 'SINGAPORE', code: 'SG' },
  { name: '세인트 헬레나', name_en: 'SAINT HELENA', code: 'SH' },
  { name: '슬로베니아', name_en: 'SLOVENIA', code: 'SI' },

  /* {name: '스발바르드 얀마이엔 제도', name_en: 'SVALBARD AND JAN MAYEN ISLANDS', code: 'SJ'}, */
  { name: '슬로바키아', name_en: 'SLOVAKIA', code: 'SK' },
  { name: '시에라리온', name_en: 'SIERRA LEONE', code: 'SL' },
  { name: '산마리노', name_en: 'SAN MARINO', code: 'SM' },
  { name: '세네갈', name_en: 'SENEGAL', code: 'SN' },
  { name: '소말리아', name_en: 'SOMALIA', code: 'SO' },
  { name: '수리남', name_en: 'SURINAME', code: 'SR' },
  { name: '남수단', name_en: 'SOUTH SUDAN', code: 'SS' },
  /* {name: '쌍투메 프린시페', name_en: 'SAO TOME AND PRINCIPE', code: 'ST'}, */
  { name: '엘살바도르', name_en: 'EL SALVADOR', code: 'SV' },

  { name: '신트마르텐', name_en: 'SINT MAARTEN (DUTCH PART)', code: 'SX' },
  { name: '시리아', name_en: 'SYRIAN ARAB REPUBLIC', code: 'SY' },
  { name: '스와질랜드', name_en: 'SWAZILAND', code: 'SZ' },
  /* {name: '터크스 카이코스 제도', name_en: 'TURKS AND CAICOS ISLANDS', code: 'TC'}, */
  { name: '차드', name_en: 'CHAD', code: 'TD' },
  /* {name: '프랑스 남부지역', name_en: 'FRENCH SOUTHERN TERRITORIES', code: 'TF'}, */
  { name: '토고', name_en: 'TOGO', code: 'TG' },
  { name: '태국', name_en: 'THAILAND', code: 'TH' },
  { name: '타지키스탄', name_en: 'TAJIKISTAN', code: 'TJ' },
  { name: '토켈라우', name_en: 'TOKELAU', code: 'TK' },

  { name: '동티모르', name_en: 'EAST TIMOR', code: 'TL' },
  { name: '투르크메니스탄', name_en: 'TURKMENISTAN', code: 'TM' },
  { name: '튀니지', name_en: 'TUNISIA', code: 'TN' },
  { name: '통가', name_en: 'TONGA', code: 'TO' },
  { name: '터키', name_en: 'TURKEY', code: 'TR' },
  { name: '트리니다드토바고', name_en: 'TRINIDAD AND TOBAGO', code: 'TT' },
  { name: '투발루', name_en: 'TUVALU', code: 'TV' },
  { name: '대만', name_en: 'TAIWAN', code: 'TW' },
  { name: '탄자니아', name_en: 'TANZANIA', code: 'TZ' },
  { name: '우크라이나', name_en: 'UKRAINE', code: 'UA' },

  { name: '우간다', name_en: 'UGANDA', code: 'UG' },
  { name: '미국령 소군도', name_en: 'UNITED STATES MINOR OUTLYING ISLANDS', code: 'UM' },
  { name: '미국', name_en: 'UNITED STATES', code: 'US' },
  { name: '우루과이', name_en: 'URUGUAY', code: 'UY' },
  { name: '우즈베키스탄', name_en: 'UZBEKISTAN', code: 'UZ' },
  { name: '바티칸', name_en: 'VATICAN CITY STATE', code: 'VA' },
  { name: '세인트 빈센트 그레나딘스', name_en: 'SAINT VINCENT AND THE GRENADINES', code: 'VC' },
  { name: '베네수엘라', name_en: 'VENEZUELA', code: 'VE' },
  /*     {name: '영국령 버진아일랜드', name_en: 'VIRGIN ISLANDS (BRITISH)', code: 'VG'},
      {name: '미국령 버진아일랜드', name_en: 'VIRGIN ISLANDS (U.S.)', code: 'VI'}, */

  { name: '베트남', name_en: 'VIET NAM', code: 'VN' },
  { name: '바누아투', name_en: 'VANUATU', code: 'VU' },
  { name: '사모아', name_en: 'SAMOA', code: 'WS' },
  { name: '예멘', name_en: 'YEMEN', code: 'YE' },
  { name: '마요트', name_en: 'MAYOTTE', code: 'YT' },
  { name: '유고슬라비아', name_en: 'YUGOSLAVIA', code: 'YU' },
  { name: '남아프리카공화국', name_en: 'SOUTH AFRICA', code: 'ZA' },
  { name: '잠비아', name_en: 'ZAMBIA', code: 'ZM' },
  { name: '자이르', name_en: 'ZAIRE', code: 'ZR' },
  { name: '짐바브웨', name_en: 'ZIMBABWE', code: 'ZW' },

  { name: '말레이시아', name_en: 'MALAYSIA', code: 'MY' },
  { name: '국적불명', name_en: 'UNKNOWN', code: 'ZZ' },
])

const LANGUAGE = Object.freeze([
  { name: '영어', o_name: 'English', code: 'en' },
  { name: '한국어', o_name: '한국어', code: 'ko' },
  { name: '덴마크어', o_name: 'Dansk', code: 'da' },
  { name: '그리스어', o_name: 'Ελληνικά', code: 'el' },
  { name: '에스토니아어', o_name: 'Eestlane', code: 'et' },

  { name: '필란드어', o_name: 'Suomen kielen', code: 'fi' },
  { name: '아일랜드어', o_name: 'Gaeilge', code: 'ga' },
  { name: '헝가리어', o_name: 'magyar', code: 'hu' },
  { name: '이탈리아어', o_name: 'italiano', code: 'it' },
  { name: '크로아티아어', o_name: 'hrvatski', code: 'hr' },

  { name: '리투아니아어', o_name: 'Lietuvis', code: 'lt' },
  { name: '노르웨이어', o_name: 'Norsk', code: 'no' },
  { name: '포르투칼어', o_name: 'Português', code: 'pt' },
  { name: '루마니아어', o_name: 'românesc', code: 'ro' },
  { name: '세르비아어', o_name: 'Српски', code: 'sr-CS' },

  { name: '슬로베니아어', o_name: 'Slovensko', code: 'sl' },
  { name: '터키어', o_name: 'Türk', code: 'tr' },
  { name: '중국어(간체)', o_name: '简体中文', code: 'zh-chs' },
  { name: '중국어(번체)', o_name: '繁體中文', code: 'zh-cht' },
  { name: '우크라이나어', o_name: 'Українська', code: 'uk-UA' },

  { name: '태국어', o_name: 'ไทย', code: 'th' },
  { name: '슬로바키아어', o_name: 'slovenský', code: 'sk' },
  { name: '러시아어', o_name: 'русский', code: 'ru' },
  { name: '스웨덴어', o_name: 'Svenska', code: 'sv' },
  { name: '폴란드어', o_name: 'Polski', code: 'pl' },

  { name: '네덜란드어', o_name: 'Nederlands', code: 'nl' },
  { name: '라트비아어', o_name: 'Latvietis', code: 'lv' },
  { name: '일본어', o_name: '日本語', code: 'ja' },
  { name: '히브리어', o_name: 'עברית', code: 'he' },
  { name: '힌디어', o_name: 'हिन्दी', code: 'hi' },

  { name: '프랑스어', o_name: 'Le français', code: 'fr' },
  { name: '스페인어', o_name: 'Espanol', code: 'es' },
  { name: '아랍어', o_name: 'العربية', code: 'ar-XA' },
  { name: '독일어', o_name: 'Deutsch', code: 'de' },
  { name: '체코어', o_name: 'Česky', code: 'cs' },

  { name: '불가리아어', o_name: 'български', code: 'bg' },
])

// 앨범 형식
const RELEASE_TYPE = Object.freeze([
  { code: 'single', name: 'Single' },
  { code: 'ep', name: 'EP' },
  { code: 'album', name: 'Album' },
])
const ARTIST_TYPE = Object.freeze([
  { code: 'solo_male', name: '남성 솔로' },
  { code: 'solo_female', name: '여성 솔로' },
  { code: 'group_male', name: '남성 그룹' },
  { code: 'group_female', name: '여성 그룹' },
  { code: 'group_combined', name: '혼성 그룹' },
])

const SNS_TYPE = Object.freeze([
  { code: 'youtube', name: 'Youtube' },
  { code: 'facebook', name: 'Facebook' },
  { code: 'twitter', name: 'Twitter' },
  { code: 'instagram', name: 'Instagram' },
  { code: 'website', name: 'Website' },
])

// 유통 상태
const ALBUM_STATE = Object.freeze([
  { code: 'registration_complete', name: '접수' },
  { code: 'inspection_complete', name: '검수완료' },
  { code: 'distribution_complete', name: '유통완료' },
  { code: 'registration_canceled', name: '유통취소' },
  { code: 'suspended', name: '유통중단' },
  { code: 'rejected', name: '반려' },
  { code: 'release_complete', name: '발매완료' },
])

// 앨범 신청 방법
const ALBUM_SOURCE = Object.freeze([
  { code: 'direct', name: 'Direct' },
  { code: 'sftp', name: 'FTP' },
  { code: 'easyupload', name: 'Easy Upload' },
])

// 신청 구분
const COPYRIGHT_TYPE = Object.freeze([
  { code: 'new', name: '신규' },
  { code: 'transfer', name: '이관' },
])

// Youtube CID 관리사
const YOUTUBE_CID = Object.freeze([
  { code: 'none', name: '없음' },
  { code: 'consalad', name: '콘샐러드' },
  { code: 're-1', name: '리원' },
  { code: 'soribada', name: '소리바다' },
])

// 트랙 유형
const TRACK_TYPE = Object.freeze([
  { code: 'original', name: 'Original' },
  { code: 'live', name: 'Live' },
  { code: 'instrumental', name: 'Instrumental' },
  { code: 'acoustic', name: 'Acoustic' },
  { code: 'acapella', name: 'Acapella' },
  { code: 'extended_version', name: 'Extended Version' },
  { code: 'radio_edit', name: 'Radio Edit' },
  { code: 'clean', name: 'Clean' },
  { code: 'cover', name: 'Cover' },
  { code: 'remastered', name: 'Remastered' },
  { code: 're_recorded', name: 'Re Recorded' },
  { code: 'remix', name: 'Remix' },
  { code: 'remake', name: 'Remake' },
  { code: 'soundtrack', name: 'Soundtrack' },
  { code: 'bonus_track', name: 'Bonus Track' },
  { code: 'hidden_track', name: 'Hidden Track' },
])


export default Object.freeze({
  MAX_COMPONENT_ITEM_COUNT: 20,
  MUSIC_STORE_KOREA: 'korea',
  MUSIC_STORE_OTHER: 'other',
  TERRITORY_GLOBAL: 'global',
  TERRITORY_KOREA: 'korea',

  COUNTRY,
  LANGUAGE,
  RELEASE_TYPE,
  ALBUM_STATE,
  ALBUM_SOURCE,
  COPYRIGHT_TYPE,
  YOUTUBE_CID,
  TRACK_TYPE,
  ARTIST_TYPE,
  SNS_TYPE,
})
